"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var FloatMarker = /** @class */ (function (_super) {
    tslib_1.__extends(FloatMarker, _super);
    function FloatMarker(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setRef = function (el) {
            _this.$el = el;
        };
        _this.state = { rendered: false };
        _this.willUnmount = false;
        return _this;
    }
    FloatMarker.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.willUnmount) {
                _this.setState({ rendered: true });
            }
        });
    };
    FloatMarker.prototype.componentWillUnmount = function () {
        this.willUnmount = true;
    };
    FloatMarker.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, theme = _b.theme, top = _b.top, left = _b.left, width = _b.width, height = _b.height, others = tslib_1.__rest(_b, ["children", "className", "theme", "top", "left", "width", "height"]);
        var rendered = this.state.rendered;
        var classes = classnames_1.default(theme["float-marker"], className, (_a = {},
            _a[theme.rendered] = rendered,
            _a));
        var styles = {
            transform: (left ? "translateX(" + left + "px)" : "") + " " + (top ? "translateY(" + top + "px)" : ""),
            width: width,
            height: height
        };
        return (React.createElement("div", tslib_1.__assign({ ref: this.setRef, className: classes, style: styles }, others), children));
    };
    FloatMarker.defaultProps = {};
    return FloatMarker;
}(React.Component));
exports.default = FloatMarker;
